<template>
    <div style="border-radius:8px" class="card pt-0 mb-3 bg-white px-3 py-3">
        <div class="row">
            <h4 class="card-title pl-3 pb-2 mb-0">Pengguna iOffice Plus</h4>
        </div>
        <div class="row no-gutters">
            <div class="col-md-1">
                <hr class="border-primary"/>
            </div>
            <div class="col-md-11">
                <hr/>
            </div>
        </div>
        <div id="chart">
            <apexchart type="line" height="300" v-if="status == true" :options="options" :series="series"></apexchart>
            <!-- <apexchart type="donut" height="330" v-if="status == true" :options="chartOptions" :series="series"></apexchart> -->
        </div>
    </div>
</template>

<script>
export default {
    props: ['keterangan', 'dataUser', 'transaksi'],
    data() {
        return {
            status: false,
            options: {
                stroke: {
                    curve: 'smooth',
                },
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: []
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let value = val.toString()
                            let leng = value.length
                            let sisa 	= leng % 3
                            let rupiah 	= value.substr(0, sisa)
                            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                
                            if (ribuan) {
                                let separator = sisa ? '.' : ''
                                rupiah += separator + ribuan.join('.')
                            }
                            return rupiah
                        }
                    },
                },
                zoom: {
                    enabled: false
                },
                color: ['#008FFB', '#D7263D']
            },
            series: []
        }
    },
    watch: {
        keterangan() {
            this.status = false
            this.getData()
        },
        dataUser() {
            this.status = false
            this.getData()
        },
    },
    methods: {
        getData() {
            this.options =  {
                stroke: {
                    curve: 'smooth',
                },
                chart: {
                    id: 'vuechart-example'
                },
                xaxis: {
                    categories: this.keterangan
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            let value = val.toString()
                            let leng = value.length
                            let sisa 	= leng % 3
                            let rupiah 	= value.substr(0, sisa)
                            let ribuan 	= value.substr(sisa).match(/\d{3}/g)
                                
                            if (ribuan) {
                                let separator = sisa ? '.' : ''
                                rupiah += separator + ribuan.join('.')
                            }
                            return rupiah
                        }
                    },
                },
                zoom: {
                    enabled: false
                },
                color: ['#008FFB', '#D7263D']
            }
            this.series = []
            var j = 0
            let intt = []
            for(j=0;j<this.dataUser.length;j++) {
                intt.push(parseInt(this.dataUser[j]))
            }
            let onPush = {
                name: 'Total User',
                data: intt,
                color: '#008FFB'
            }
            this.series.push(onPush)
            this.getSeries2()
        },
        getSeries2() {
            var i = 0
            let int = []
            for(i=0;i<this.transaksi.length;i++) {
                int.push(parseInt(this.transaksi[i]))
            }
            let onPush = {
                name: 'Total Transaksi Dashboard',
                data: int,
                color: '#D7263D'
            }
            this.series.push(onPush)
            this.status = true
        }
    },
    mounted() {
    },
}
</script>
<style scoped>
.card-title {
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
    height: 100%;
}
</style>